import type { AtlasEvent } from "../types.js";

/** Subscribes to the gateway event bus (/api/events) with auto-reconnect. */
export class EventStream {
  private ws?: WebSocket;
  private closed = false;

  constructor(private onEvent: (ev: AtlasEvent) => void) {}

  start(): void {
    this.closed = false;
    this.open();
  }

  private open(): void {
    const proto = location.protocol === "https:" ? "wss" : "ws";
    const ws = new WebSocket(`${proto}://${location.host}/api/events`);
    this.ws = ws;
    ws.onmessage = (e) => {
      try {
        this.onEvent(JSON.parse(e.data) as AtlasEvent);
      } catch {
        /* ignore malformed */
      }
    };
    ws.onclose = () => {
      if (!this.closed) setTimeout(() => this.open(), 2000);
    };
    ws.onerror = () => ws.close();
  }

  stop(): void {
    this.closed = true;
    this.ws?.close();
  }
}
